import React from 'react';
import { useDispatch } from 'react-redux';
import FlipIcon from '@mui/icons-material/Flip';

import { hasAssemblyPermission as hasAssemblyPermissionSelector } from '@paragon/login-tools';

import { useAppMonitor } from '../../../monitor';
import { isLayoutCameraInUse } from '../../../store/selectors/layoutModeSelectors';
import { cameraSlice } from '../../../store/slices/camera/cameraSlice';
import { useAppSelector } from '../../hooks';
import { ToolbarIconButton } from '../top/ToolbarIconButton';

export default function FlipButton() {
  const monitor = useAppMonitor();
  const dispatch = useDispatch();

  const hasAssemblyPermission = useAppSelector(hasAssemblyPermissionSelector);

  const disabled = useAppSelector(isLayoutCameraInUse);
  const isFlipped = useAppSelector((state) => state.camera.designSettings.flipped);

  if (!hasAssemblyPermission) return null;

  return (
    <ToolbarIconButton
      icon={<FlipIcon />}
      sx={{ transform: 'rotate(270deg)' }}
      title={`${isFlipped ? 'Unflip' : 'Flip'} Camera`}
      toggleValue={isFlipped}
      disabled={disabled}
      onClick={() => {
        if (!disabled) {
          dispatch(cameraSlice.actions.designCameraFlipped());
          monitor.recordInteraction('Component Flipped');
        }
      }}
    />
  );
}
